/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2024 ICEMEDX, Inc.
***********************************************/
import { IceEntity } from '../../core/IceEntity';

export class claimspinal extends IceEntity {
  claim_spinal_key: string = "";
  subluxation_level_code: string = "";
  subluxation_end_level_code: string = "";
  treatment_series_number: number = 0.0;
  treatment_series_count: number = 0;
  treatment_period_unit_code: string = "";
  treatment_period_count: number = 0.0;
  monthly_teatment_period_count: number = 0.0;
  nature_of_condition_code: string = "";
  complication_code: string = "";
  condition_description: string = "";
  xray_available_code: string = "";
  record_version: number = 0;
  offline_record_status: number = 0;

  constructor() {
    super();
  }

  gettablename(): string {
    return "CLAIM_SPINAL";
  }
}

